// extracted by mini-css-extract-plugin
export default {"coverLink":"eM-z","contentBox":"fM-z","zapposPromoContainer":"gM-z","zapposPromoGroupContainer":"hM-z","promos":"iM-z","bottom":"jM-z","top":"kM-z","right":"lM-z","left":"mM-z"};